import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksProducts: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
	},
	getRegulationsStagesPlanWorksProductPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT_PREVIEW,
	},
	getRegulationsStagesPlanWorksProductPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT_POPUP,
	},
	createRegulationsStagesPlanWorksProduct: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
				.CREATE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
	},
	getRegulationsStagesPlanWorksProduct: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
	},
	patchRegulationsStagesPlanWorksProduct: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
				.PATCH_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
	},
	putRegulationsStagesPlanWorksProduct: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
				.PUT_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
	},
	deleteRegulationsStagesPlanWorksProduct: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
				.DELETE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
	},
}
